import React, { useEffect, useRef } from 'react';

const annualMeeting2026 = [
  'incollage_save 31.JPG', 'incollage_save 32.JPG', 'incollage_save 33.JPG', 'incollage_save 34.JPG', 'incollage_save 39.JPG',
  'RDWN2759.jpg', 'RDWN2834.jpg', 'RDWN2838.jpg', 'RDWN2841.jpg', 'RDWN2842.jpg', 'RDWN2844.jpg',
  'RDWN2846.jpg', 'RDWN2878.jpg', 'RDWN2977.jpg', 'RDWN3099.jpg', 'RDWN3116.jpg', 'RDWN3122.jpg',
  'RDWN3228.jpg', 'RDWN3675.jpg', 'RDWN3728.jpg', 'RDWN3754.jpg', 'RDWN3795.jpg',
];

export const Gallery = () => {
  const galleryRef = useRef(null);

  useEffect(() => {
    const galleryItems = galleryRef.current.querySelectorAll('.gallery-item, .video-container, .additional-images img, .gallery-title');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        } else {
          entry.target.classList.remove('visible');
        }
      });
    }, {
      root: null, // viewport browser
      rootMargin: '0px', // default margin
      threshold: 0.5 // 50% elemen harus terlihat untuk memicu animasi
    });

    galleryItems.forEach((item) => {
      observer.observe(item);
    });

    return () => {
      galleryItems.forEach((item) => {
        observer.unobserve(item);
      });
    };
  }, []);

  return (
    <div id="gallery" className="gallery-container"  ref={galleryRef}>
      {/* Annual Meeting Aspersindo 2026 */}
      <h1 className="gallery-title fade-in-left">Annual Meeting Aspersindo 2026</h1>
      <div className="gallery-grid ppmk">
        {annualMeeting2026.map((file, i) => (
          <div key={file} className="gallery-item fade-in">
            <img src={`/img/RDWN2878/${encodeURIComponent(file)}`} alt={`Annual Meeting Aspersindo 2026 ${i + 1}`} loading="lazy" />
          </div>
        ))}
      </div>
      {/* Halal Bi Halal Aspersindo 2026 */}
      <h1 className="gallery-title fade-in-left">Halal Bil Halal Aspersindo Tahun 2026</h1>
      <div className="gallery-grid ppmk">
        <div className="gallery-item ppmk6 fade-in">
          <img src="/img/Halbi_2026/img-1.jpeg" alt="Pembukaan Pengurus 1" />
        </div>
        <div className="gallery-item ppmk1 fade-in">
          <img src="/img/Halbi_2026/img-2.jpeg" alt="Pembukaan Pengurus 2" />
        </div>
        <div className="gallery-item ppmk2 fade-in">
          <img src="/img/Halbi_2026/img-3.jpeg" alt="Pembukaan Pengurus 3" />
        </div>
        <div className="gallery-item ppmk-center fade-in">
          <img src="/img/Halbi_2026/img-4.jpeg" alt="Pembukaan Pengurus 4" />
        </div>
      </div>
      <h1 className="gallery-title fade-in-left">Kegiatan Pengurus   (mengenai Pengaman Digital dan Brand Protection)</h1>
      <div className="gallery-grid ppmk">
        <div className="gallery-item ppmk1 fade-in">
          <img src="/img/kegiatan/img-1.jpg" alt="kegiatan Pengurus 1" />
        </div>
        <div className="gallery-item ppmk2 fade-in">
          <img src="/img/kegiatan/img-2.jpg" alt="kegiatan Pengurus 2" />
        </div>
        <div className="gallery-item ppmk3 fade-in">
          <img src="/img/kegiatan/img-3.jpg" alt="kegiatan Pengurus 3" />
        </div>
        <div className="gallery-item ppmk4 fade-in">
          <img src="/img/kegiatan/img-4.jpg" alt="kegiatan Pengurus 4" />
        </div>
      </div>  
      <h1 className="gallery-title fade-in-left">Pembukaan Kantor Sekretariat yang Baru + Meeting Pengurus periode 2024 - 2027</h1>
      <div className="gallery-grid ppmk">
        <div className="gallery-item ppmk6 fade-in">
          <img src="/img/pembukaan/img-3.jpg" alt="Pembukaan Pengurus 5" />
        </div>
        <div className="gallery-item ppmk1 fade-in">
          <img src="/img/pembukaan/img-1.jpg" alt="Pembukaan Pengurus 1" />
        </div>
        <div className="gallery-item ppmk2 fade-in">
          <img src="/img/pembukaan/img-2.jpg" alt="Pembukaan Pengurus 2" />
        </div>
        <div className="gallery-item ppmk3 fade-in">
          <img src="/img/pembukaan/img-5.jpg" alt="Pembukaan Pengurus 3" />
        </div>
        <div className="gallery-item ppmk4 fade-in">
          <img src="/img/pembukaan/img-4.jpg" alt="Pembukaan Pengurus 4" />
        </div>
      </div>
      {/* Halal Bi Halal Aspersindo 2025 */}
      <h1 className="gallery-title fade-in-left">Halal Bi Halal Aspersindo 2025</h1>
      <div className="gallery-grid labuan-bajo">
        <div className="gallery-item item1 fade-in">
          <img src="/img/Halbi/galery-1.JPG" alt="Group photo at night" />
        </div>
        <div className="gallery-item item2 fade-in">
          <img src="/img/Halbi/galery-2.JPG" alt="Panel discussion" />
        </div>
        <div className="gallery-item item3 fade-in">
          <img src="/img/Halbi/galery-3.JPG" alt="Conference attendees" />
        </div>
        <div className="gallery-item item4 fade-in">
          <img src="/img/Halbi/galery-4.JPG" alt="Large group photo" />
        </div>
        <div className="gallery-item item5 fade-in">
          <img src="/img/Halbi/galery-5.jpg" alt="Group photo with raised hands" />
        </div>
        <div className="gallery-item item6 fade-in">
          <img src="/img/Halbi/galery-6.jpg" alt="Statue display" />
        </div>
        <div className="gallery-item item6 fade-in">
          <img src="/img/Halbi/galery-7.jpg" alt="Statue display" />
        </div>
      </div>
      {/* Annual Meeting Bali 2024 */}
      <h1 className="gallery-title fade-in-left">Annual Meeting Bali 2024</h1>
      <div className="gallery-grid ppmk">
        <div className="gallery-item ppmk1 fade-in">
          <img src="/img/Bali/galery-1.jpg" alt="Pelantikan Pengurus 1" />
        </div>
        <div className="gallery-item ppmk2 fade-in">
          <img src="/img/Bali/galery-2.jpg" alt="Pelantikan Pengurus 2" />
        </div>
        <div className="gallery-item ppmk3 fade-in">
          <img src="/img/Bali/galery-3.jpg" alt="Pelantikan Pengurus 3" />
        </div>
        <div className="gallery-item ppmk4 fade-in">
          <img src="/img/Bali/galery-4.jpg" alt="Pelantikan Pengurus 4" />
        </div>
        <div className="gallery-item ppmk5 fade-in">
          <img src="/img/Bali/galery-5.jpg" alt="Pelantikan Pengurus 5" />
        </div>
        <div className="gallery-item ppmk5 fade-in">
          <img src="/img/Bali/galery-6.jpg" alt="Pelantikan Pengurus 5" />
        </div>
      </div>

      <h1 className="gallery-title fade-in-left">Labuan Bajo</h1>
      <div className="gallery-grid labuan-bajo">
        <div className="gallery-item item1 fade-in">
          <img src="/img/Laboan-bajo/galery-1.jpeg" alt="Group photo at night" />
        </div>
        <div className="gallery-item item2 fade-in">
          <img src="/img/Laboan-bajo/galery-2.jpeg" alt="Panel discussion" />
        </div>
        <div className="gallery-item item3 fade-in">
          <img src="/img/Laboan-bajo/galery-3.jpeg" alt="Conference attendees" />
        </div>
        <div className="gallery-item item4 fade-in">
          <img src="/img/Laboan-bajo/galery-4.jpeg" alt="Large group photo" />
        </div>
        <div className="gallery-item item5 fade-in">
          <img src="/img/Laboan-bajo/galery-5.jpeg" alt="Group photo with raised hands" />
        </div>
        <div className="gallery-item item6 fade-in">
          <img src="/img/Laboan-bajo/galery-6.jpeg" alt="Statue display" />
        </div>
      </div>

      <div className="video-container fade-in">
        <video controls width="100%">
          <source src="/img/Laboan-bajo/vidio.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <h1 className="gallery-title fade-in-left">Pelantikan dan Pengesahan Dewan Pengawas dan Dewan Pengurus Aspersindo periode 2021-2024</h1>
      <div className="gallery-grid ppmk">
        <div className="gallery-item ppmk1 fade-in">
          <img src="/img/PPMK/galery-1.jpeg" alt="Pelantikan Pengurus 1" />
        </div>
        <div className="gallery-item ppmk2 fade-in">
          <img src="/img/PPMK/galery-2.jpeg" alt="Pelantikan Pengurus 2" />
        </div>
        <div className="gallery-item ppmk3 fade-in">
          <img src="/img/PPMK/galery-3.jpeg" alt="Pelantikan Pengurus 3" />
        </div>
        <div className="gallery-item ppmk4 fade-in">
          <img src="/img/PPMK/galery-4.jpeg" alt="Pelantikan Pengurus 4" />
        </div>
        <div className="gallery-item ppmk5 fade-in">
          <img src="/img/PPMK/galery-5.jpeg" alt="Pelantikan Pengurus 5" />
        </div>
      </div>
      
      
    </div>
  );
};